module.exports = __webpack_public_path__ + "static/media/IMG_1539.8aebc284.jpg";